export default __webpack_public_path__ + "static/media/bjj.04ad8d29.jpg";